"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackUserSearchTerm = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackUserSearchTerm(searchTerm) {
    (0, pushToDataLayer_1.pushToDataLayer)({ event: 'search', searchTerm });
}
exports.trackUserSearchTerm = trackUserSearchTerm;
//# sourceMappingURL=trackUserSearchTerm.js.map